<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.auName" style="width: 140px;" size="small "
                        placeholder="请输入姓名" clearable></el-input>
                   
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="small" style="margin-left: 10px;"
                        @click="businessOpportunitiesClicks()">转商机申请</el-button> -->
                    <!-- <el-button type="primary" size="small" style="margin-left: 10px;"
                        @click="claimClicks(4)">批量审核</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新建题库分类</el-button> -->

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="qprId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-dialog :title="edit ? '编辑题库分类' : '新增题库分类'" :visible.sync="dialog" width="70%" top="8vh">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:65vh">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">

                        <el-form-item label="题库分类" prop="auName">
                            <el-input v-model="form.auName" type="textarea" style="width: 50%;"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 性格测试 -->
            <el-dialog title="测试详情" :visible.sync="isText" width="70%" top="8vh" :close-on-press-escape="false"
                :close-on-click-modal="false" @close="isTextClose">
                
                <!-- <div v-if="topicArr.qprStatus == 2 && topicArr.qpId == 4" style="padding: 0 50px;">
                    <p style="width: 100%;font-size: 19px;margin: 15px 50px 0;">
                        <span>客观题得分 : {{ topicArr.qprObjectiveScore }}</span>
                        <span style="margin-left: 10px;">主观题得分: {{ topicArr.qprScore }}</span>
                        <span style="margin-left: 10px;">最终得分 : {{ topicArr.qprShowScore }}</span>
                    </p>
                </div> -->
                <div class="textclass"
                    style="width: 100%;overflow-y: auto;padding: 50px 50px 15px;overflow-x: hidden;height:350px"
                    :style="{ 'height': topicArr.qprStatus == 2 && topicArr.qpId == 7? '600px' : '600px' }">
                    <div id="" v-for="(item, index) in topicArr.ivqPaperTopicList || []" :key="index">
                        <p style="margin: 15px 0;font-size: 16px;">{{ index
                        + 1 }}.({{ item.qttName }}){{ item.qtName }}</p>
                        <el-radio-group v-model="checkList[index][0]" v-if="item.qttId != 2 && item.qttId != 4"
                            v-for="(topic, n) in item.ivqTopicItemList" :key="n" style="display:block;"
                            text-color="red">
                            <el-radio :label="topic.qtiId" style="margin: 5px;" size="medium" border
                                v-model="item.qptAnswerIds" disabled>{{
                        topic.qtiValue }}</el-radio>
                        </el-radio-group>
                        <el-checkbox-group v-model="checkList[index]" v-if="item.qttId == 2"
                            v-for="(topic, n) in item.ivqTopicItemList" :key="n" text-color="red">
                            <el-checkbox disabled :label="topic.qtiId" style="margin: 5px;" size="medium" border>{{
                        topic.qtiValue
                    }}</el-checkbox>
                        </el-checkbox-group>
                        <el-input disabled type="textarea" :rows="4" style="width: 100%;margin-left:0px;"
                            v-model="checkList[index]" placeholder="请输入答案"
                            v-if="item.qttId == 4 || item.qttId == 5"></el-input>
                        <el-input type="number" style="width: 70%;margin-left:0px;margin-top: 20px;"
                            v-model="qtScoreUser[index]" placeholder="请给简答题打分"
                            v-if="item.qttId == 4 || item.qttId == 5"></el-input>
                        <el-button type="success" size="small" v-if="item.qttId == 4 || item.qttId == 5"
                            @click="qtScoreUserTap(item, index)">打分</el-button>
                        <div :style="{
                        color: item.qtScoreRight == 1 ? '#F56C6C' : '#67C23A',
                    }" v-if="item.qttId != 4 && item.qttId != 5">
                            {{ item.qtScoreRight == 1 ? "错误" : "正确" }}
                        </div>
                        <div v-if="item.qtScoreRight == 1" style="width: 100%;display: flex;color:#67C23A ;">
                        正确答案是:
                        <template v-for="(topics, val) in item.ivqTopicItemList">
                            <div v-if="topics.qtiIsAnswer == 2">{{ topics.qtiValue }},</div>
                        </template>

                    </div>
                    </div>
                </div>
            </el-dialog>
        </div>

    </div>
</template>

<script>

import {
     updateIvqPaperRecordScoreSubject,
    addIvqTopicClass, deleteIvqTopicClass, getIvqPaperRecordAssetsList, updateIvqTopicClass, getIvqPaperRecordDetails,
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            qtScoreUser: [],
            getIvqPaperRecordAssetsList_data: [],
            checkList: [],
            isText: false,
            topicArr: [],
            fromArr: [],
            limit: 1,
            visitfileList: [],
            getNcVisitorItemList_data: [],
            getNcVisitorList_data: [],
            userarr: [],
            level_Four: [],
            level_Three: [],
            key: 'qprId',
            dialog: false,
            edit: false,
            form: {

            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (column.key == "characterAnalysis") {
                        return "Table_center table-header-cell-class";
                    }
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "qpName",
                    key: "qpName",
                    fixed: 'left',
                    title: "测试名称",
                    width: 150,
                    align: "center",
                    edit: false,

                },
                {
                    field: "createusername",
                    key: "createusername",
                    fixed: 'left',
                    title: "姓名",
                    width: 100,
                    align: "center",
                    edit: false,

                },
              
                {
                    field: "qprShowScore",
                    key: "qprShowScore",
                    title: "最终得分",
                    width: 100,
                    align: "center",
                    edit: false,

                },
                
                {
                    field: "createtime",
                    key: "createtime",
                    fixed: 'left',
                    title: "创建时间",
                    width: 180,
                    align: "center",
                    edit: false,

                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.qprStatus == 2 ?
                                        <el-button
                                            size="mini"
                                            type="text"
                                            style={{ 'color': row.characterCode }}
                                            on-click={() => this.DetailText(row)}>
                                            查看
                                        </el-button> : ''
                                }
                                
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                auName: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getIvqPaperRecordAssetsList({ qpStatus: 2 }).then(res => {
            this.getIvqPaperRecordAssetsList_data = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        isTextClose() {
            this.partserch();
            this.isText = false
        },
        qtScoreUserTap(row, index) {
            updateIvqPaperRecordScoreSubject({ qptId: row.qptId, qtScoreUser: this.qtScoreUser[index] }).then(res => {
                this.topicArr.qprScore = res.data.qprScore;
                this.topicArr.qprShowScore = res.data.qprShowScore;
            })
        },
        DetailText(row) {
            if (row.qprId) {
                getIvqPaperRecordDetails({ qprId: row.qprId }).then(res => {
                    this.topicArr = res.data;
                    this.checkList = [];
                    for (var i = 0; i < res.data.ivqPaperTopicList.length; i++) {
                        if (res.data.ivqPaperTopicList[i].qttId == 4 || res.data.ivqPaperTopicList[i].qttId == 5) {
                            this.checkList.push((res.data.ivqPaperTopicList[i].qptAnswerIds || ''))
                            this.$set(this.qtScoreUser, i, (res.data.ivqPaperTopicList[i].qtScoreUser || ''))
                        } else {
                            this.checkList.push((res.data.ivqPaperTopicList[i].qptAnswerIds || '').split(',').map(Number))
                        }

                    }
                    this.isText = true;
                })
            }
        },
        fromChange(e) {
            this.fromArr = [];
            if (e == 1) {
                getNcClueList({ pageSize: 0 }).then((res) => {
                    res.data.forEach((item, index) => {
                        const s = {
                            name: item.ncName,
                            id: item.ncId
                        }
                        this.fromArr.push(s)
                    })
                });
            } else if (e == 2) {
                getNcNicheList({ pageSize: 0 }).then((res) => {
                    res.data.forEach((item, index) => {
                        const s = {
                            name: item.nnName,
                            id: item.nnId
                        }
                        this.fromArr.push(s)
                    });
                })
            } else {
                getNcNicheProjectList({ pageSize: 0 }).then((res) => {
                    res.data.forEach((item, index) => {
                        const s = {
                            name: item.nnpName,
                            id: item.nnpId
                        }
                        this.fromArr.push(s)
                    });
                })
            }
        },
        visitfileChange(file) {
            this.$set(this.form, 'nvsFiles', file[0])
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },

        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteIvqTopicClass({ qprIds: row.qprId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;

            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addIvqTopicClass(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateIvqTopicClass(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();

        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.qprId = row.qprId
                    //console.log(jsonObj);
                    updateIvqTopicClass(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getIvqPaperRecordAssetsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getIvqPaperRecordAssetsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getIvqPaperRecordAssetsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.textclass .el-radio--medium.is-bordered {
    width: 100% !important;
    height: auto !important;
    padding: 5px 15px !important;
}

.textclass .el-radio {
    white-space: inherit !important;
    line-height: 2 !important;
}

.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.Table_center {
    text-align: center !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>